import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';

const Mathematics = () => {
  return (
    <PageTemplate
      title="Matematik Bölümü"
      subtitle="Matematik Bölümü Sayfası"
    >
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <p className="text-gray-700 text-lg">
            Matematik Bölümü sayfası yakında güncellenecektir.
          </p>
          <p className="text-gray-600 mt-4">
            Daha fazla bilgi için bölüm web sitesini ziyaret edebilirsiniz:{' '}
            <a
              href="https://mat.hacettepe.edu.tr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              mat.hacettepe.edu.tr
            </a>
          </p>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Mathematics;
